import { forwardRef, useEffect, useMemo } from 'react'

export const AudioOptions = forwardRef((props, ref) => {
  const {
    showJoinLeaveAudioButton,
    speakerMode,
    microphoneMode,
    showMicrophoneButton,
    showTimer,
    timerLimit,

    onChange = () => {}
  } = props

  const shouldDisableTimerLimit = useMemo(() => {
    return !showTimer || (speakerMode || microphoneMode)
  }, [showTimer, speakerMode, microphoneMode])

  const shouldDisableShowTimer = useMemo(() => {
    return (speakerMode || microphoneMode)
  }, [speakerMode, microphoneMode])

  const shouldDisableShowMicrophoneButton = useMemo(() => {
    return !speakerMode
  }, [speakerMode])

  useEffect(() => {
    console.log({
      showJoinLeaveAudioButton,
      speakerMode,
      microphoneMode,
      showMicrophoneButton,
      showTimer,
      timerLimit,
    })
  }, [props])

  return (
    <>
      <div className="row mb-4 audio-join-options">
        <div className="col-sm-5">Show Join/Leave Audio Button</div>
        <div className="col-sm-7">
          <select
            value={showJoinLeaveAudioButton}
            onChange={e => {
              const value = Number(e.target.value)
              const payload = {
                showJoinLeaveAudioButton: value,
                showMicrophoneButton: value ? 1 : 0,
                microphoneMode: !value ? 1 : 0,
                speakerMode: !value ? 1 : 0,
                showTimer: !value ? 0 : 1,
                timerLimit: !value ? 0 : 10,
              }

              if (!value) payload.speakerMode = 1

              onChange(payload)
            }}
            className="form-control"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      {showJoinLeaveAudioButton === 0 && (
        <div className="row mb-4 audio-join-options">
          <div className="col-sm-5">Speaker</div>
          <div className="col-sm-7">
            <select
              value={speakerMode}
              onChange={e => {
                const value = Number(e.target.value)

                const payload = { speakerMode: value }

                if (!value) {
                  payload.showMicrophoneButton = 0
                  payload.microphoneMode = 0
                  payload.showTimer = 0
                  payload.timerLimit = 0
                }

                onChange(payload)
              }}
              className="form-control"
            >
              <option value="1">Always On</option>
              <option value="0">Always Off</option>
            </select>
          </div>
        </div>
      )}

      {showJoinLeaveAudioButton === 0 && (
        <div className="row mb-4 mic-join-options">
          <div className="col-sm-5">Show Microphone Button</div>
          <div className="col-sm-7">
            <select
              value={showMicrophoneButton}
              onChange={e => {
                onChange({
                  showMicrophoneButton: Number(e.target.value)
                })
              }}
              className="form-control"
              disabled={shouldDisableShowMicrophoneButton}
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
      )}


      {(showMicrophoneButton === 0 && showJoinLeaveAudioButton === 0) && (
        <div className="row mb-4 audio-join-options">
          <div className="col-sm-5">Mic</div>
          <div className="col-sm-7">
            <select
              value={microphoneMode}
              onChange={e => {
                onChange({
                  microphoneMode: Number(e.target.value)
                })
              }}
              className="form-control"
              disabled={!speakerMode}
            >
              <option value="1">Always On</option>
              <option value="0">Always Off</option>
            </select>
          </div>
        </div>
      )}

      <div className="row mb-4 show-timer">
        <div className="col-sm-5">Show Timer</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <select
            value={showTimer}
            onChange={e => {
              const value = Number(e.target.value)
              const payload = {
                showTimer: value,
                timerLimit: value ? 10 : 0
              }

              onChange(payload)
            }}
            className="form-control"
            disabled={shouldDisableShowTimer}
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>

      <div className="row mb-4 show-timer-limit">
        <div className="col-sm-5">Timer Limit (minutes)</div>
        <div className="col-sm-7 d-flex justify-content-end">
          <input
            min={1}
            max={1440}
            type="number"
            className="form-control"
            placeholder="Interval time"
            value={timerLimit}
            onChange={e => {
              onChange({ timerLimit: Number(e.target.value)})
            }}
            disabled={shouldDisableTimerLimit}
          />
        </div>
      </div>
    </>
  )
})
